import React, { useMemo, useState } from "react";
import "./BidResponsesOverview.scss";
import AvatarImage from "../../Components/AvatarImage/AvatarImage";

const ACCEPTED_OFFERS = [
  {
    id: 1,
    type: "doctor",
    name: "Dr. Ashmita Mukherjee",
    subtitle: "Cardiologist",
    experience: "12 years experience",
    rating: 4.7,
    distance: "1.2 km",
    amount: "Rs.10,000",
    availability: "Availability : Mon - Fri : 11am - 3 pm",
    image:
      "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?q=80&w=300&auto=format&fit=crop",
    km: 25,
    price: 10000,
  },
  {
    id: 2,
    type: "hospital",
    name: "Charnock Hoso-pital",
    subtitle: "Medical center - Facility fee INC.",
    experience: "Newtown, Kolkata",
    rating: 4.9,
    distance: "1.2 km",
    amount: "Rs.12,000",
    availability: "Availability : Mon - Fri : 11am - 3 pm",
    image:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=300&auto=format&fit=crop",
    km: 25,
    price: 12000,
  },
  {
    id: 3,
    type: "patient",
    name: "Shreya Das",
    subtitle: "Age : 29 yrs",
    experience: "Chinar Park, VIP, Kolkata",
    rating: null,
    distance: null,
    amount: "Rs.15,000",
    availability: "Preferable Slot : March - April",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=300&auto=format&fit=crop",
    km: 25,
    price: 15000,
  },
  {
    id: 4,
    type: "doctor",
    name: "Dr. Ria Sen",
    subtitle: "General Surgeon",
    experience: "10 years experience",
    rating: 4.8,
    distance: "4.5 km",
    amount: "Rs.8,500",
    availability: "Availability : Mon - Sat : 10am - 2 pm",
    image:
      "https://images.unsplash.com/photo-1594824476967-48c8b964273f?q=80&w=300&auto=format&fit=crop",
    km: 10,
    price: 8500,
  },
  {
    id: 5,
    type: "hospital",
    name: "Apollo Clinic",
    subtitle: "Diagnostic & Consultation Center",
    experience: "Salt Lake, Kolkata",
    rating: 4.6,
    distance: "7.8 km",
    amount: "Rs.9,500",
    availability: "Availability : Mon - Fri : 9am - 1 pm",
    image:
      "https://images.unsplash.com/photo-1586773860418-d37222d8fce3?q=80&w=300&auto=format&fit=crop",
    km: 10,
    price: 9500,
  },
  {
    id: 6,
    type: "doctor",
    name: "Dr. Priyanka Dey",
    subtitle: "Neurologist",
    experience: "15 years experience",
    rating: 4.9,
    distance: "18 km",
    amount: "Rs.10,000",
    availability: "Availability : Tue - Sat : 12pm - 5 pm",
    image:
      "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?q=80&w=300&auto=format&fit=crop",
    km: 25,
    price: 10000,
  },
];

const DENIED_OFFERS = [
  {
    id: 7,
    type: "doctor",
    name: "Dr. Sourav Ghosh",
    subtitle: "Orthopaedic Specialist",
    experience: "8 years experience",
    rating: 4.4,
    distance: "14 km",
    amount: "Rs.18,000",
    availability: "Denied : Price exceeds expected budget",
    image:
      "https://images.unsplash.com/photo-1537368910025-700350fe46c7?q=80&w=300&auto=format&fit=crop",
    km: 25,
    price: 18000,
  },
  {
    id: 8,
    type: "hospital",
    name: "Fortis Hospital",
    subtitle: "Premium tertiary care center",
    experience: "EM Bypass, Kolkata",
    rating: 4.7,
    distance: "22 km",
    amount: "Rs.20,000",
    availability: "Denied : Distance and cost mismatch",
    image:
      "https://images.unsplash.com/photo-1504439468489-c8920d796a29?q=80&w=300&auto=format&fit=crop",
    km: 25,
    price: 20000,
  },
];

const KM_OPTIONS = [
  { label: "Within 5 Km", value: 5 },
  { label: "Within 10 Km", value: 10 },
  { label: "Within 25 Km", value: 25 },
  { label: "Within 50 Km", value: 50 },
];

const PRICE_OPTIONS = [
  { label: "Within Rs. 5,000", value: 5000 },
  { label: "Within Rs. 10,000", value: 10000 },
  { label: "Within Rs. 15,000", value: 15000 },
  { label: "Within Rs. 20,000", value: 20000 },
];

const SORT_OPTIONS = [
  { label: "Most Relevant", value: "relevant" },
  { label: "Lowest Price", value: "lowPrice" },
  { label: "Highest Price", value: "highPrice" },
  { label: "Nearest", value: "nearest" },
];

function getStars(rating) {
  if (!rating) return null;
  const full = Math.round(rating);
  return "★".repeat(full);
}

export default function BidResponsesOverview() {
  const [activeTab, setActiveTab] = useState("accepted");
  const [selectedKm, setSelectedKm] = useState(25);
  const [selectedPrice, setSelectedPrice] = useState(10000);
  const [sortBy, setSortBy] = useState("relevant");

  const acceptedCount = ACCEPTED_OFFERS.length;
  const deniedCount = DENIED_OFFERS.length;

  const sourceData = activeTab === "accepted" ? ACCEPTED_OFFERS : DENIED_OFFERS;

  const filteredData = useMemo(() => {
    let data = sourceData.filter(
      (item) => item.km <= selectedKm && item.price <= selectedPrice
    );

    if (sortBy === "lowPrice") {
      data = [...data].sort((a, b) => a.price - b.price);
    } else if (sortBy === "highPrice") {
      data = [...data].sort((a, b) => b.price - a.price);
    } else if (sortBy === "nearest") {
      data = [...data].sort((a, b) => a.km - b.km);
    }

    return data;
  }, [sourceData, selectedKm, selectedPrice, sortBy]);

  return (
    <div className="bid-overview-page">
      <div className="container">
        <div className="bid-overview-wrap">
          <div className="bid-overview-header">
            <h1>Bid Responses Overview</h1>
            <p>
              Monitor all bids and counter bids between patients, doctors, and hospitals
              and track how each request progresses.
            </p>
          </div>

          <div className="bid-top-panel">
            <div className="bid-tabs-row">
              <button
                type="button"
                className={`bid-tab ${activeTab === "accepted" ? "active" : ""}`}
                onClick={() => setActiveTab("accepted")}
              >
                Accepted Offers
                <span className="count-pill accepted">{acceptedCount}</span>
              </button>

              <button
                type="button"
                className={`bid-tab ${activeTab === "denied" ? "active deniedActive" : ""}`}
                onClick={() => setActiveTab("denied")}
              >
                Denied Offers
                <span className="count-pill denied">{deniedCount}</span>
              </button>
            </div>

            <div className="bid-filters-row">
              <div className="bid-filters-left">
                <select
                  value={selectedKm}
                  onChange={(e) => setSelectedKm(Number(e.target.value))}
                >
                  {KM_OPTIONS.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>

                <select
                  value={selectedPrice}
                  onChange={(e) => setSelectedPrice(Number(e.target.value))}
                >
                  {PRICE_OPTIONS.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="bid-filters-right">
                <span>Sort By</span>
                <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
                  {SORT_OPTIONS.map((item) => (
                    <option key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="bid-cards-list">
            {filteredData.length > 0 ? (
              filteredData.map((item) => (
                <div className="bid-card" key={item.id}>
                  <div className="bid-card-main">
                    <div className="bid-left">
                      <div className="bid-avatar">
                        <AvatarImage
                          src={item.image}
                          alt={item.name}
                          name={item.name}
                          className="bid-avatar-img"
                          fallbackClassName="bid-avatar-img"
                        />
                      </div>

                      <div className="bid-info">
                        <h3>{item.name}</h3>
                        <p className="sub">{item.subtitle}</p>
                        <p className="exp">{item.experience}</p>

                        {item.rating ? (
                          <div className="bid-meta">
                            <span className="stars">{getStars(item.rating)}</span>
                            <span className="rating">{item.rating}</span>
                            <span className="distance">| {item.distance}</span>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    <div className="bid-right">
                      <div className="amount">{item.amount}</div>
                    </div>
                  </div>

                  <div className="bid-card-footer">{item.availability}</div>
                </div>
              ))
            ) : (
              <div className="empty-state">
                No {activeTab === "accepted" ? "accepted" : "denied"} offers found for the selected filter.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}